/**
 * The panel's one reading of the wall clock.
 *
 * The core gets time injected so its tests are deterministic; a browser screen
 * saying "12 min ago" is the edge where ambient time is simply correct. Keeping
 * the read in one file means the lint rule is relaxed for exactly this file,
 * and everything else in the panel still goes through here.
 */
export function now(): Date {
  return new Date();
}
